






import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE } from '@/store/modules/authentication/types';
import { Client } from '@/store/modules/authentication/interfaces';

import { traceLogAccess } from '@/services';
import { ContextEnum } from '@/enums/context.enum';
import { ClientEnum } from '@/enums/client.enum';
import { TupleDictionary } from '@/utils/tupleDictionary';

import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import { CountryEnum, CountryType } from '@/enums/country.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';
import { VehicleTypeEnum } from '@/enums/vehicle-type.enum';

@Component({
  name: 'Pbi2wPartsIntelligencePage',
  components: { ReportPowerBiContainer }
})
export default class Pbi2wPartsIntelligencePage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();

  public dictReports = new TupleDictionary<[ClientEnum, VehicleTypeEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum['Honda Moto Peças'], VehicleTypeEnum.Motorcycle, CountryEnum.Brasil], { brand: 'Honda Moto Peças', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '8dfe87ed-5d65-4def-99ad-acfa58178a43' });

    console.log(JSON.stringify(this.dictReports))

    this.crrReport = this.dictReports.get([this.client.id, this.idVehicleType, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - 2W Parts Intelligence`);
  }
}
